import { queryKey as campaignTimelineQueryKey, useGetCampaignTimeline } from './useGetCampaignTimeline';
import { queryKey as campaignListQueryKey, useGetCampaignList } from './useGetCampaignList';
import {
  queryKey as customerCampaignMessageHistoryQueryKey,
  useGetCustomerCampaignMessageHistory,
} from './useGetCustomerCampaignMessageHistory';

export default {
  queryKey: {
    campaignList: campaignListQueryKey,
    campaignTimeline: campaignTimelineQueryKey,
    customerCampaignMessageHistory: customerCampaignMessageHistoryQueryKey,
  },
  useGetCampaignList,
  useGetCampaignTimeline,
  useGetCustomerCampaignMessageHistory,
};
